import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-contesto-label',
    templateUrl: './contesto-label.component.html',
    styleUrls: ['./contesto-label.component.scss'],
    standalone: false
})
export class ContestoLabelComponent {
  @Input() contesto = 0;
}
